import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MapService } from '../../../services/map.service';
import { RoutingService } from '../../../services/routing.service';
import { LANDMARKS } from '../../management-tab/landmarks-sub-tab/landmarks-routing.constants';

@Component({
  selector: 'tutorial-polygon',
  templateUrl: './tutorial-polygon.component.html',
  styleUrls: ['./tutorial-polygon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTooltipModule, TranslatePipe, MatTabsModule],
})
export class TutorialPolygonComponent implements OnInit, OnDestroy {
  private componentDestroy$ = new Subject<void>();
  public isDeployed: boolean;
  public selectedIndex = 0;
  public actionsData: string[] = ['CREATE', 'VALIDATE', 'EDIT', 'DELETE'];
  public actionsGif: string[] = [
    'assets/poly_create.webm',
    'assets/poly_valid.webm',
    'assets/poly_edit.webm',
    'assets/poly_delete.webm',
  ];
  public readonly LANDMARKS = LANDMARKS;

  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup;

  constructor(
    private mapService: MapService,
    public routingService: RoutingService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.mapService.isTutorialOpen$
      .pipe(takeUntil(this.componentDestroy$))
      .subscribe(isActive => (this.isDeployed = isActive));
  }

  ngOnDestroy(): void {
    this.selectedIndex = 0;
    this.mapService.isTutorialOpen$.next(false);
    this.componentDestroy$.next();
    this.componentDestroy$.complete();
  }

  public toggleDeploy(): void {
    this.mapService.isTutorialOpen$.next(!this.mapService.isTutorialOpen$.getValue());
    this.selectedIndex = 0;
  }

  public changeIndex(index: number, step: number): void {
    let newIndex = index + step;
    newIndex =
      newIndex > this.actionsData.length - 1 ? this.actionsData.length - 1 : newIndex < 0 ? 0 : newIndex;
    this.selectedIndex = newIndex;
    if (step !== 0) this.scrollElement(step);
  }

  private scrollElement(step: number): void {
    const element = document.getElementsByClassName('mat-tab-list')[0];
    if (element) {
      step === 1 ? (element.scrollLeft += 300) : (element.scrollLeft -= 300);
    }
  }
}
